import { fetchCollection, queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { useQuery } from "@tanstack/react-query";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { Divider, List, Typography } from "@mui/material";
import FormDraft from "../../../types/FormDraft";
import React from "react";
import PdfGeneratorDraftListItem from "./PdfGeneratorDraftListItem";
import { UseFormReturn } from "react-hook-form";
import { CasePdfGeneratorFormValues } from "../../../types/CasePdfGenerator";
import { getMediaObjectFilters } from "../../../services/mediaObjectService";
import { ProductUnion } from "../../../types/ProductUnion";

type CaseFormDraftDisplayProps = {
  product: ProductUnion;
  formContext: UseFormReturn<CasePdfGeneratorFormValues>;
};

const PdfGeneratorDraftList = ({ product, formContext }: CaseFormDraftDisplayProps) => {
  const currentUser = useCurrentUser();
  const formDraftFilter = { backofficeCase: product.backofficeCase.id };

  const mediaObjectsFilter = getMediaObjectFilters(product, currentUser);
  const { data: mediaObjectsCollection } = useQuery({
    queryKey: queryKeys.collection("media_objects", mediaObjectsFilter),
    queryFn: () => fetchCollection("media_objects", mediaObjectsFilter),
    enabled: !!product
  });

  const { data: formDraftResponse } = useQuery({
    queryKey: queryKeys.collection("form_drafts", formDraftFilter),

    queryFn: () =>
      fetchCollection("form_drafts", formDraftFilter)
  });

  if (!formDraftResponse || formDraftResponse["hydra:totalItems"] === 0 || currentUser.isExternal || !mediaObjectsCollection) {
    return null;
  }

  return (
    <>
      <Typography variant={"h5"} sx={{ padding: "16px" }}>
        <strong>Entwurf verwenden</strong>
      </Typography>
      <Divider />
      <List sx={{ marginBottom: "2rem" }}>
        {(formDraftResponse?.["hydra:member"] || []).map((formDraft: FormDraft<CasePdfGeneratorFormValues>) => (
          <PdfGeneratorDraftListItem
            product={product}
            formDraft={formDraft}
            formContext={formContext}
            key={formDraft.id}
            mediaObjects={mediaObjectsCollection["hydra:member"]}
          />
        ))}
      </List>
    </>
  );
};

export default PdfGeneratorDraftList;
